import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {useMemo, useRef, useMemo as useMemoReact, useState, useEffect} from "react";
import {Button} from "primereact/button";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import {form} from "framer-motion/m";
import AgregarIncapacidadDialog from "./AddIncapacidad";
import Swal from "sweetalert2";
import {getIncapacidadChofer, insertIncapacidad} from "./integracion";
import useGetDataUser from "../../../utilidades/customHooks/useGetDataUser";

// Expect props: { data: array }

const TablaIncapacidad = ({   userName = "", choferId }) => {
    const dtRef = useRef(null);
    const [openAdd, setOpenAdd] = useState(false);
    const [incapacidades, setIncapacidades] = useState([]);
    const [user, setUser] = useState(null);
    const [tiposIncapacidad, setTiposIncapacidad] = useState([])

    const dataUser = useGetDataUser()

    const loadIncapacidades = async () => {

        try {
            const incapacidades = await getIncapacidadChofer(choferId)
            setIncapacidades(incapacidades)
        } catch (e) {
            console.log(e)
            setIncapacidades([])
        }
    }
    useEffect(() => {
        loadIncapacidades()
        getTiposIncapacidad()
    }, []);
    useEffect(() => {


        if (dataUser?.user?.ID) {
            setUser({ ID: dataUser.user.ID });
        }
    }, [dataUser])
console.log(dataUser)
    const columns = useMemo(
        () => [
            { field: "FECHA_INICIO", header: "FECHA INICIO" },
            { field: "DIAS", header: "DIAS" },
            { field: "FECHA_FIN", header: "FECHA FIN" },
            { field: "FECHA_TRABAJAR", header: "FECHA TRABAJAR" },
            { field: "TIPO_INCAPACIDAD", header: "TIPO INCAPACIDAD" },
            { field: "FOLIO_INCAPACIDAD", header: "FOLIO INCAPACIDAD" },
            { field: "COMENTARIOS", header: "COMENTARIOS" }
        ],
        []
    );

    const getTiposIncapacidad = async () => {

        try{
            const res = await getTiposIncapacidad()
            setTiposIncapacidad(res.data)
        } catch (e) {
            console.log(e)
        }
    }

    const handleSaveIncapacidad = async (payload) => {


        // Aquí llama a tu API para crear la incapacidad y refrescar lista, con swal de respuesta
        Swal.fire({
            title: 'Cargando...',
            text: 'Subiendo incapacidad...',
            allowOutsideClick: false,  // Evita que el modal se cierre haciendo clic fuera
            allowEscapeKey: false,     // Evita que el modal se cierre con la tecla ESC
            didOpen: () => {
                Swal.showLoading();     // Muestra el spinner de carga
            }
        });

        try {
            const res = await insertIncapacidad(payload)
            const success = res?.success === true || res?.ok === true; // soporta variantes

            if (success) {
                Swal.fire({
                    icon: 'success',
                    title: 'Incapacidad cargada exitosamente',
                    text: 'La incapacidad ha sido cargada exitosamente.',
                    confirmButtonText: 'Aceptar'
                });
               await loadIncapacidades()
            } else {
                console.log(res)
                Swal.fire({
                    icon: 'error',
                    title: 'Error al cargar la incapacidad',
                });
            }
        }catch (e) {
            console.log(e)
            Swal.fire({
                title: 'Error al cargar la incapacidad',
                icon: 'error',
            })
        }

        setOpenAdd(false);
    };

    const isValid = useMemoReact(() => {
        const { fechaInicio, fechaFin, fechaTrabajar } = form;
        if (!fechaInicio || !fechaFin || !fechaTrabajar) return false;
        // inicio <= fin, y fechaTrabajar >= fin
        const start = new Date(fechaInicio.getFullYear(), fechaInicio.getMonth(), fechaInicio.getDate());
        const end = new Date(fechaFin.getFullYear(), fechaFin.getMonth(), fechaFin.getDate());
        const back = new Date(fechaTrabajar.getFullYear(), fechaTrabajar.getMonth(), fechaTrabajar.getDate());
        if (start > end) return false;
        if (back < end) return false;
        return true;
    }, [form]);

    const printTable = () => {
        const style = `
      <style>
        table { border-collapse: collapse; width: 100%; font-family: Arial, sans-serif; font-size: 12px; }
        th, td { border: 1px solid #ccc; padding: 6px 8px; text-align: left; }
        th { background: #f5f5f5; }
        h2 { font-family: Arial, sans-serif; }
      </style>
    `;
        const title = `<h2>${baseTitle}</h2>`;
        const tableHtml = buildPlainHtmlTable(columns, incapacidades);
        const win = window.open("", "PRINT", "height=700,width=1000");
        if (win) {
            win.document.write(style + title + tableHtml);
            win.document.close();
            win.focus();
            win.print();
        }
    };

    const safeUser = (userName || "usuario").trim().replace(/[\\/:*?"<>|]+/g, "");
    const baseTitle = `Incapacidades - ${safeUser}`;
    const baseFile = `incapacidades_${safeUser || "usuario"}`;

    const buildPlainHtmlTable = (cols, rows) => {
        const thead = `<thead><tr>${cols.map(c => `<th>${c.header}</th>`).join("")}</tr></thead>`;
        const tbody = `<tbody>${
            (rows || [])
                .map(r => `<tr>${cols.map(c => `<td>${r?.[c.field] ?? ""}</td>`).join("")}</tr>`)
                .join("")
        }</tbody>`;
        return `<table>${thead}${tbody}</table>`;
    };
    const exportCSV = () => {
        dtRef.current?.exportCSV({ selectionOnly: false, exportHeader: true, filename: baseFile });
    };
    const exportPDF = () => {
        const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "A4" });
        const head = [columns.map(c => c.header)];
        const body = (incapacidades || []).map(row => columns.map(c => row?.[c.field] ?? ""));

        doc.text(baseTitle, 40, 40);
        // Usar la función importada explícitamente
        autoTable(doc, {
            startY: 60,
            head,
            body,
            styles: { fontSize: 8, cellPadding: 4 },
            headStyles: { fillColor: [33, 150, 243] }
        });
        doc.save(`${baseFile}.pdf`);
    };

    if (!incapacidades || incapacidades.length === 0) {
        return (
            <div style={{ display: "flex", flexDirection: 'column', justifyContent: "center", alignItems: "center", minHeight: 160 }}>
                <Button icon="pi pi-file-plus" label="Agregar incapacidad" style={{ backgroundColor: "#008a78"}} onClick={() => setOpenAdd(true)} />

                <span style={{ color: "#777", fontWeight: 600 }}>Sin incapacidades</span>

                <AgregarIncapacidadDialog
                    visible={openAdd}
                    onHide={() => setOpenAdd(false)}
                    defaultName={userName}
                    onSave={handleSaveIncapacidad}
                    choferId={choferId}
                    userId={user?.ID ?? null}
                />
            </div>
        );
    }

    const header = (
        <div style={{ display: "flex", gap: '8px' }}>
            <Button icon="pi pi-file-plus" label="Agregar incapacidad" style={{ backgroundColor: "#008a78"}} onClick={() => setOpenAdd(true)} />
            <Button icon="pi pi-file-excel" label="Excel" onClick={exportCSV} style={{ backgroundColor: "#236003"}}/>
            <Button icon="pi pi-file-pdf" label="PDF" onClick={exportPDF} className="p-button-sm p-button-danger" />
            <Button icon="pi pi-print" onClick={printTable} label="Imprimir" />

        </div>
    );

    return (
        <>
        <DataTable ref={dtRef} value={incapacidades} header={header}>
            <Column field="FECHA_INICIO" dataType="date" header="FECHA INICIO" style={{ width: '10%' }}></Column>
            <Column field="DIAS" header="DIAS"></Column>
            <Column field="FECHA_FIN" dataType="date" header="FECHA FIN"></Column>
            <Column field="FECHA_TRABAJAR" dataType="date" header="FECHA TRABAJAR"></Column>
            <Column field="TIPO_INCAPACIDAD" header="TIPO INCAPACIDAD" style={{ width: '10%' }}></Column>
            <Column field="FOLIO_INCAPACIDAD" header="FOLIO INCAPACIDAD" style={{ width: '10%' }}></Column>
            <Column field="COMENTARIOS" header="COMENTARIOS"></Column>
        </DataTable>

    <AgregarIncapacidadDialog
        visible={openAdd}
        onHide={() => setOpenAdd(false)}
        defaultName={userName}
        onSave={handleSaveIncapacidad}
        choferId={choferId}
        userId={user?.ID ?? null}
    />
        </>
    );
};


export default TablaIncapacidad;